const filterPrice =  function(value, fractionDigits = 2, prefix = '$', suffix = '') {
    if (typeof value === 'string') return value;
    return prefix + (value / 100).toFixed(fractionDigits) + suffix;
}

export default filterPrice;
